import CityCentre from "@Icons/CityCenter";
import styles from "./ScrollStyles.module.scss";
import Ripple from "@Components/Ripple";
import UniversityIcon from "@Icons/UniversityIcon";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

const MAX_PLACE_LENGTH = 31;

type DistanceScrollPropType = {
  data: {
    place: string;
    distance: number;
  };
  onClick?: any;
  className?: string;
};

const DistanceScroll = ({ data, onClick, className }: DistanceScrollPropType) => {
  const placeName = data?.place;

  // if university name has more than 30 characters we need to show at max 30 characters only
  const getPlace = (place: any) => {
    if (place?.length < MAX_PLACE_LENGTH) return place;

    const newPlaceName = `${place.slice(0, MAX_PLACE_LENGTH)}...`;
    return newPlaceName;
  };

  return (
    <>
      {data?.place !== "" ? (
        <div className={formatClassNames(styles.parentContainer, className)}>
          {!!onClick && <Ripple onClick={onClick} />}
          <div className={styles.journeyContainer} data-testid="distance-pills">
            <div className={styles.iconContainer}>
              {placeName === "city center" ? <CityCentre /> : <UniversityIcon />}
            </div>
            <div data-testid="university-distance-from-property" className={styles.info}>
              <div className={styles.cityName}>
                {getPlace(placeName)} | {data?.distance}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default wrapperHOC(DistanceScroll, {
  componentName: "DistanceScroll-PropertyDetailsSection-PropertyPage",
  showForChina: true,
});
